const roleNamesJetpackGame = {
  standardJetpackGame: 'standardJetpackGame',
}

const roleNamesWhereOnEarth = {
  standardWhereOnEarth: 'standardWhereOnEarth',
}

const roleNamesWooorld = {
  alphaTester: 'alphaTester',
  ambassador: 'ambassador',
  assistant1: 'assistant1',
  assistant1_7Day: 'assistant1_7Day',
  assistant2: 'assistant2',
  assistant2_7Day: 'assistant2_7Day',
  assistant3: 'assistant3',
  assistant3Trial1Day: 'assistant3Trial1Day',
  assistant3Trial6Month: 'assistant3Trial6Month',
  assistant3_7Day: 'assistant3_7Day',
  betaTester: 'betaTester',
  dev: 'dev',
  devAdmin: 'devAdmin',
  explorerPlus: 'explorerPlus',
  explorerPlusFounder: 'explorerPlusFounder',
  jetpack: 'jetpack',
  jetpackTrial1Day: 'jetpackTrial1Day',
  moderator: 'moderator',
  playerPlus: 'playerPlus',
  playerPlusFounder: 'playerPlusFounder',
  premium2024: 'premium2024',
  standard: 'standard',
  supporter1: 'supporter1',
  supporter2: 'supporter2',
  supporter3: 'supporter3',
  tester: 'tester',
};

const roleNames = {
  ...roleNamesJetpackGame,
  ...roleNamesWhereOnEarth,
  ...roleNamesWooorld,
};

const folderFilterOptions = {
  all: null,
  createdByUser: 'createdByUser',
};

const folderSortOptions = {
  creationDateAsc: 'creationDateAsc',
  creationDateDesc: 'creationDateDesc',
  labelAsc: 'labelAsc',
  labelDesc: 'labelDesc',
  recommended: 'recommended',
};

const pinFilterOptions = {
  all: null,
  createdByUser: 'createdByUser',
  likedByUser: 'likedByUser',
  only3d: 'only3d',
  hot: 'hot',
};

const pinSortOptions = {
  creationDateAsc: 'creationDateAsc',
  creationDateDesc: 'creationDateDesc',
  labelAsc: 'labelAsc',
  labelDesc: 'labelDesc',
  likes: 'likes',
  owner: 'owner', // used by VR app to determine if a pin has been saved TODO: separate API for findOne
};

const creditSources = {
  accrual: 'accrual', // recurring credit, determined by a role's budget, typically expires
  adminGift: 'adminGift', // when issued by an admin via Goood
  consumable: 'consumable', // Meta store purchased consumable - consumed in exchange for credits
  earn: 'earn', // credit issued by app for some in-app accomplishment or reward
  grant: 'grant', // one-time credit issued by a role
  refund: 'refund', // currently used only for deleting pins. freemium Wooorld users have 10 'pins' credits. deleting a pin gives them that a credit back
  spend: 'spend', // credit spent by user in app
};

const creditTypes = {
  clankBux: 'clankBux',
  searchNearbyGoogle: 'searchNearbyGoogle',
  searchAutocompleteGoogle: 'searchAutocompleteGoogle',
  tourCreate: 'tourCreate',
  pins: 'pins',
  playBoosted: 'playBoosted',
  playStandard: 'playStandard',
}

const jetpackClankers = {
  raceTracksById: {
    0: {
      id: 0,
      label: 'Infinity Loop',
    },
    1: {
      id: 1,
      label: 'Aero Core',
    },
    2: {
      id: 2,
      label: 'Widowmaker',
    },
  },
};

module.exports = {
  creditTypes,
  creditSources,
  appNames: {
    jetpackGame: 'JetpackGame',
    whereOnEarth: 'WhereOnEarth',
    wooorld: 'Wooorld',
  },
  appTargets: {
    beta: 'beta',
    demo: 'demo',
    dev: 'dev',
    local: 'local',
    prod: 'prod',
  },
  goood: {
    tours: {
      filters: {
        complete: 'complete',
        createdByUser: 'createdByUser',
        deleted: 'deleted',
        likedByUser: 'likedByUser',
      }
    },
    users: {
      filters: {
        alphaTester: 'alphaTester',
        explorer: 'explorer',
        founder: 'founder',
        isDev: 'isDev',
        online: 'online',
        player: 'player',
      }
    },
    worlds: {
      filters: {
        appNameJetpackGame: 'appNameJetpackGame',
        appNameWhereOnEarth: 'appNameWhereOnEarth',
        appNameWooorld: 'appNameWooorld',
      },
      sorts: {
        oldest: 'oldest',
        newest: 'newest',
        userCount: 'userCount',
      },
    }
  },
  jetpackClankers,
  folderFilterOptions,
  folderSortOptions,
  pinFilterOptions,
  pinSortOptions,
  roles: {
    allRoleNames: Object.values(roleNames),
    jetpackGameRoleNames: Object.values(roleNamesJetpackGame),
    whereOnEarthRoleNames: Object.values(roleNamesWhereOnEarth),
    wooorldRoleNames: Object.values(roleNamesWooorld),
    roleAssignmentSources: {
      admin: 'admin', // admin manually add/remove
      iapConsumable: 'iapConsumable', // user purchased
      iapDurable: 'iapDurable', // user purchased
      iapSubscription: 'iapSubscription', // user purchased
      metaSubscriptionBypass: 'metaSubscriptionBypass', // user purchased
      system: 'system', // system assigned
    },
    roleNames,
  },
  worldTypes: {
    Canvas: 'Canvas',
    CraterRun: 'CraterRun',
    Explore: 'Explore',
    Game: 'Game',
    SoloDressingRoom: 'SoloDressingRoom',
    Spaceport: 'Spaceport',
  },
}
